import { Td } from '@chakra-ui/react'
import { HiOutlineExternalLink } from 'react-icons/hi'
import { Song } from 'services/openai'

import * as S from './styled'

type Props = {
  song: Song
}

export const Row = ({ song }: Props) => {
  const navigateToYouTube = () => {
    const url = `https://www.youtube.com/results?search_query=${song.title}+by+${song.artist}`

    window.open(url, '_blank')
  }

  return (
    <S.TableRow onClick={navigateToYouTube}>
      <Td>{song.title}</Td>
      <Td>{song.artist}</Td>
      <Td className='link'>
        <HiOutlineExternalLink />
      </Td>
    </S.TableRow>
  )
}
